import React from 'react';
import styled from 'styled-components';
import Popper from '@material-ui/core/Popper';

import { Close } from 'components';
import { FaEllipsisH } from 'react-icons/fa';
import Modal from '@material-ui/core/Modal';

const defaultStyle = {
    backgroundColor: 'var(--secondary-color)',
    fontSize: '0.9rem',
    fontWeight: 'normal',
    lineHeight: '1rem',
    height: 'auto',
    padding: '0.4rem 0.5rem',
    margin: 0,
    border: null,
    iconMinWidth: '1.5rem',
    borderBottom: null,
    borderRadius: '5px'
}


const Container = styled.div`
    /* display: grid;
    grid-template-columns: minmax(0, min-content) auto; */
    /* display: flex; */
    /* align-items: center; */
    box-sizing: border-box;
    background-color: ${props => props.styles.backgroundColor};
    border-bottom: ${props => props.styles.borderBottom};
    font-size: ${props => props.styles.fontSize};
    font-weight: ${props => props.styles.fontWeight};
    margin: ${props => props.styles.margin};
    height: ${props => props.styles.height};
    line-height: ${props => props.styles.lineHeight};
    border-radius: ${props => props.styles.borderRadius};
    cursor: ${props => props.clickable && 'pointer'};
    border: ${props => props.styles.border};
    flex-shrink: 0;
    display: flex;
    align-items: center;
    :hover{
        filter: ${props => props.clickable && 'brightness(var(--brightness))'};
    }
`

const Row = styled.div`
    width: 100%;
    display: grid;
    grid-template-columns: ${props => props.trailing ? '1fr auto' : props.icon ? '1rem 1fr auto' : '1fr auto'};
    grid-column-gap: 0.5rem;
    border-radius: 5px;
    align-items: center;
    padding: ${props => !props.trailing && props.styles.padding};
`

const RowContent = styled.div`
    width: 100%;
    padding: ${props => props.styles.padding};
    display: grid;
    grid-template-columns: ${props => props.icon ? '1rem 1fr auto' : '1fr auto'};
    grid-column-gap: 0.5rem;
    border-radius: 5px;
    align-items: center;
`

const Text = styled.div`
    /* line-height: 1.2rem; */
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    color: ${props => props.selected && 'white'};
    color: ${props => props.styles && props.styles['color']};
`

const Icon = styled.div`
    z-index: 2;
    min-width: ${props => props.styles.iconMinWidth};
    color: ${props => props.styles && props.styles['iconColor']};
    display:flex;
    align-items: center;
`

const ListTile = props => {
    const {
        backgroundColor,
        icon,
        text,
        onSelect,
        styles,
        trailingIcon,
        trailingPersist,
        contextMenu,
        contextIcon,
        ref
    } = props;

    const [anchorEl, setAnchorEl] = React.useState(null);
    const [open, openPopper] = React.useState(false);
    const [showTrailing, setTrailing] = React.useState(false);

    const clickHandler = (event) => {
        event && event.preventDefault();
        setAnchorEl(anchorEl ? null : event.currentTarget);
        openPopper(!open);
    }

    const updatedStyle = Object.assign({}, defaultStyle, styles)
    const contextMenuAdj = contextMenu && React.cloneElement(contextMenu, {closeHandler: clickHandler})
    if(trailingIcon) {
        return(
            <Container ref={ref} 
                clickable={onSelect} styles={updatedStyle} 
                onMouseEnter={() => !trailingPersist && setTrailing(true)} 
                onMouseLeave={() => !trailingPersist && setTrailing(false)}>
                <Row trailing={trailingIcon}
                    styles={updatedStyle}
                    onContextMenu={contextMenuAdj ? clickHandler : null}>
                    <RowContent icon={icon} onClick={onSelect} styles={updatedStyle}>
                        {icon ? <Icon styles={updatedStyle}>{icon}</Icon> : null}
                        <Text styles={styles}>{text}</Text>
                    </RowContent>
                    {(trailingIcon && showTrailing) | trailingPersist ? <div style={{paddingRight: '0.5rem'}}>{trailingIcon}</div> : null}
                </Row>
                <Modal onBackdropClick={clickHandler} open={open} BackdropProps={{invisible:true, zIndex: 1301}}>
                    <Popper style={{zIndex: 1301, outline: 'none'}} open={open} anchorEl={anchorEl} placement={props.placement ? props.placement : 'bottom-end'}>
                        {contextMenuAdj}
                    </Popper>
                </Modal>
            </Container>
        )
    }
    else if(contextMenuAdj){
        return (
            <Container ref={ref} clickable={onSelect} styles={updatedStyle} onMouseEnter={() => setTrailing(true)} onMouseLeave={() => !open && setTrailing(false)}>
                <Row icon={icon} onClick={onSelect} onContextMenu={clickHandler} styles={updatedStyle}>
                    {icon ? <Icon styles={updatedStyle}>{icon}</Icon> : null}
                    <Text styles={styles}>{text}</Text>
                    <Icon styles={updatedStyle} onClick={clickHandler}>{contextIcon || <FaEllipsisH/>}</Icon> 
                </Row>
                <Modal onBackdropClick={clickHandler} open={open} BackdropProps={{invisible:true, zIndex: 1301}}>
                    <Popper style={{zIndex: 1301, outline: 'none'}} open={open} anchorEl={anchorEl} placement={props.placement ? props.placement : 'bottom-end'}>
                        {contextMenuAdj}
                    </Popper>
                </Modal>
            </Container>
        )
    } else {
        return(
            <Container ref={ref} clickable={onSelect} styles={updatedStyle} onMouseEnter={() => !trailingPersist && setTrailing(true)} onMouseLeave={() => !trailingPersist && setTrailing(false)}>
                <Row icon={icon} onClick={onSelect} onContextMenu={contextMenuAdj ? clickHandler : null} styles={updatedStyle}>
                    {icon ? <Icon styles={updatedStyle}>{icon}</Icon> : null}
                    <Text styles={styles}>{text}</Text>
                    {(trailingIcon && showTrailing) | trailingPersist ? trailingIcon : null}
                </Row>
            </Container>
        )
    }
    
}

export default ListTile;